import React from "react";
import { Card } from "../modules/Contacts";

export function ContactsCardPage(props) {
  return <Card {...props} />;
}
